import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NotificationListDatum } from '@core/models/admin/account/notification.model';
import { PushNotifiactionData } from './notification.service';

const STORAGE_KEY = 'notification_logs';

@Injectable({ providedIn: 'root' })
export class NotificationLogService {
  private logsSubject = new BehaviorSubject<NotificationListDatum[]>(
    this.loadFromStorage()
  );

  logs$ = this.logsSubject.asObservable();

  private loadFromStorage(): NotificationListDatum[] {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? (JSON.parse(raw) as NotificationListDatum[]) : [];
    } catch {
      return [];
    }
  }

  private saveToStorage(logs: NotificationListDatum[]): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(logs));
    } catch {
      // Storage quota exceeded — silently ignore
    }
  }

  addLog(
    payload: PushNotifiactionData,
    response: { success: number; failed: number }
  ): void {
    const total = response.success + response.failed;

    const entry: NotificationListDatum = {
      id: crypto.randomUUID(),
      title: payload.title || '(No Title)',
      preview: payload.message,
      type: this.mapPushType(payload.push_type),
      sent: total,
      delivered: response.success,
      failed: response.failed,
      date: new Date().toISOString(),
      status: response.success === 0 ? 'failed' : 'completed',
    };

    const updated = [entry, ...this.loadFromStorage()];
    this.saveToStorage(updated);
    this.logsSubject.next(updated);
  }

  getLogs(): NotificationListDatum[] {
    return this.loadFromStorage();
  }

  private mapPushType(pushType: string): string {
    switch (pushType?.toUpperCase()) {
      case 'RICH':
        return 'Rich Push';
      case 'INTERACTIVE':
        return 'Interactive';
      case 'SILENT':
        return 'Silent';
      default:
        return pushType ?? 'Unknown';
    }
  }
}
